export default __webpack_public_path__ + "static/media/cb7b39d08d77534fe5bde3c6f169e4c0.gif";